module.exports = __webpack_public_path__ + "img/goldregen-2020-062.d00b20cf.jpg";